// Business days the real estate has to open an objection after the inspection is finished.
// Same bounds and default as hcheck, where the rule runs.
export const MIN_DISPUTE_CREATION_DAYS_LIMIT = 1
export const MAX_DISPUTE_CREATION_DAYS_LIMIT = 60
export const DEFAULT_DISPUTE_CREATION_DAYS_LIMIT = 11

export const isEmptyDisputeCreationDaysLimit = (value) =>
  value === null || value === undefined || `${value}`.trim() === ''

// The backend keeps the current value when it receives null, so clearing a deadline that was set
// sends the default explicitly; a deadline that was never set stays null (hcheck default).
export const toDisputeCreationDaysLimitBody = (value, loadedValue) => {
  if (isEmptyDisputeCreationDaysLimit(value)) {
    return isEmptyDisputeCreationDaysLimit(loadedValue) ? null : DEFAULT_DISPUTE_CREATION_DAYS_LIMIT
  }

  return Number(value)
}
